import React from "react";
import moment from "moment-timezone";
import values from "lodash/values";
import groupBy from "lodash/groupBy";
import { Link, Navigation } from "react-router";
import { capitalize, formatPrice } from "../../util";
import { RaisedButton, MenuItem } from "material-ui";
import TicketList from "./ticket-list/ticket-list.jsx";
import PassList from "./pass-list/pass-list.jsx";
import InjectedTenantHTML from "./injected-tenant-html.jsx";
import InjectedTenantScripts from "./injected-tenant-scripts.jsx";

import CogButtonMenu from "./cog-button-menu.jsx";
import SmsTicketsWidgetSundance from "./sms-tickets-widget-sundance.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import PassStore from "../../stores/PassStore";
import EventStore from "../../stores/EventStore";
import OrderActions from "../../actions/OrderActions";
import EventActions from "../../actions/EventActions";

@connectToStores
class OrderSummarySundance extends React.Component {
  constructor(props) {
    super(props);

    this.getSundanceDisplayTag = this.getSundanceDisplayTag.bind(this);
    this.getSundanceVenueCity = this.getSundanceVenueCity.bind(this);
    this.getUnlockInterval = this.getUnlockInterval.bind(this);
  }

  static getStores() {
    return [TicketStore, PassStore, EventStore];
  }

  static getPropsFromStores() {
    return {
      getPassById: PassStore.getPassById,
      getTicketById: TicketStore.getTicketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object.isRequired,
      isLarge: React.PropTypes.bool,
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object
    };
  }

  componentWillMount() {
    // Set global order variables for use in injected scripts
    // See https://help.eventive.org/integrations/adding-additional-scripts
    let { order } = this.props;
    window.PERSON_ID = order.person ? order.person.id : "<unknown id>";
    window.PERSON_EMAIL = order.person
      ? order.person.details.email
      : "<unknown email>";
    window.ORDER_ID = order.id;
    window.PURCHASE_PRICE = order.purchase_price / 100;
    window.NET_PRICE = order.net_price / 100;
    let ticketEventIds = [];
    window.TICKETS = order.tickets.map(t => {
      ticketEventIds.push(t.event.id);
      return {
        id: t.id,
        event_id: t.event.id,
        event_name: t.event.name,
        ticket_bucket_id: t.ticket_bucket.id,
        ticket_bucket_name: t.ticket_bucket.name,
        price: order._items[t.id].price / 100
      };
    });
    EventActions.fetchAll.defer({ eventIds: ticketEventIds });
    window.PASSES = order.passes.map(p => {
      return {
        id: p.id,
        pass_bucket_id: p.pass_bucket.id,
        pass_bucket_name: p.pass_bucket.name,
        price: order._items[p.id].price / 100
      };
    });
    window.ITEMS = order.items.map(i => {
      return {
        id: i.id,
        item_bucket_id: i.item_bucket.id,
        item_bucket_name: i.item_bucket.name,
        price: order._items[i.id].price / 100
      };
    });
    window.GIFT_CARD_ORDER = order.gift_cards && order.gift_cards.length ? true : false;
  }

  getStyles() {
    return {
      container: {
        textAlign: "left",
        width: "90%"
      },
      general: {
        textAlign: "left",
        paddingTop: 20
      },
      innerContainer: {
        fontSize: "12pt",
        lineHeight: 1.5,
        color: "rgba(0,0,0,0.54)"
      },
      h2: {
        margin: 0,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        color: "rgb(33,33,33)"
      },
      h3: {
        margin: 0
      },
      orderId: {
        textTransform: "uppercase",
        wordWrap: "break-word",
        fontFamily: "monospace",
        letterSpacing: "-1px"
      },
      inOrderSubhead: {
        textAlign: "center",
        color: "rgb(33,33,33)"
      },
      listing: {
        border: "1px solid #ccc",
        borderRadius: 10,
        marginBottom: "1em"
      },
      actions: {
        marginTop: 20,
        textAlign: "center"
      },
      items: {
        padding: "0"
      },
      sundanceCheckoutButtonContainer: {
        textAlign: "center",
        marginTop: 30
      },
      sundanceCheckoutButton: {
        backgroundColor: "#333",
        color: "#fff",
        borderRadius: 5
      },
      sundanceCheckoutButtonLabel: {
        fontSize: "0.8em"
      },
      error: {
        marginBottom: 10,
        textAlign: "center",
        color: "#FF4136"
      }
    };
  }

  // Return "PREMIERE" if tag exists or return "SCREENING" otherwise
  getSundanceDisplayTag(event) {
    if (!event.tags) {
      return "SCREENING";
    }
    else {
      if (event.tags.find(obj => { return obj.name.toUpperCase() === "PREMIERE"})) {
        return "PREMIERE";
      }
      else {
        return "SCREENING";
      }
    }
  }

  // Return "Park City" or "Salt Lake City" or "Boulder" based on venue location
  getSundanceVenueCity(venue) {
    if (this.context.tenant.sundance_salt_lake_city_venues &&
        this.context.tenant.sundance_salt_lake_city_venues.length &&
        this.context.tenant.sundance_salt_lake_city_venues.includes(venue.id)) {
      return "Salt Lake City";
    } else if (this.context.tenant.sundance_boulder_venues &&
        this.context.tenant.sundance_boulder_venues.length &&
        this.context.tenant.sundance_boulder_venues.includes(venue.id)) {
      return "Boulder";
    } else {
      return "Park City";
    }
  }

  getUnlockInterval(ticketEvent, creationMoment) {

    const event = this.props.event || ticketEvent;
    const appSettings = this.context.appSettings;

    // NOTES on unlock window calculation

    // NON-DATED VIRTUAL EVENTS
    // if event.is_dated === false and event.virtual_intervals is null
    //   -> unlock window is now() until now() + appSettings.virtual_festival_config.unlock_interval

    // if event.is_dated === false and event.virtul_intervals is not null
    //   -> unlock window is now() until now() + event.virtual_intervals.unlock_interval

    // DATED VIRTUAL EVENTS
    // if event.is_dated === true and event.virtual_intervals is null

    //   if event.start_time > now() and event.end_time > event.start_time + appSettings.virtual_festival_config.unlock_interval
    //      -> unlock window is event.start_time until event.start_time + appSettings.virtual_festival_config.unlock_interval
    //   if event.start_time > now() and event.end_time <= event.start_time + appSettings.virtual_festival_config.unlock_interval
    //      -> unlock window is event.start_time until event.end_time

    //   if event.start_time <= now() and event.end_time > event.start_time + appSettings.virtual_festival_config.unlock_interval
    //      -> unlock window is now() until now() + appSettings.virtual_festival_config.unlock_interval
    //   if event.start_time <= now() and event.end_time <= event.start_time + appSettings.virtual_festival_config.unlock_interval
    //      -> unlock window is now() until event.end_time

    // if event.is_dated === true and event.virtual_intervals is not null

    //   if event.start_time > now() and event.end_time > event.start_time + event.virtual_intervals.unlock_interval
    //      -> unlock window is event.start_time until event.start_time + event.virtual_intervals.unlock_interval
    //   if event.start_time > now() and event.end_time <= event.start_time + event.virtual_intervals.unlock_interval
    //      -> unlock window is event.start_time until event.end_time

    //   if event.start_time <= now() and event.end_time > event.start_time + event.virtual_intervals.unlock_interval
    //      -> unlock window is now() until now() + event.virtual_intervals.unlock_interval
    //   if event.start_time <= now() and event.end_time <= event.start_time + event.virtual_intervals.unlock_interval
    //      -> unlock window is now() until event.end_time

    let unlockStart = moment();
    let unlockEnd = moment();

    // Undated Event
    if (event && !event.is_dated) {
      if (event.virtual_intervals && event.virtual_intervals.unlock_interval) {
        unlockStart = creationMoment;
        unlockEnd = moment(creationMoment).add(event.virtual_intervals.unlock_interval, 'ms');
      }
      else if (!event.virtual_intervals) {
        unlockStart = creationMoment;
        unlockEnd = moment(creationMoment).add(appSettings.virtual_festival_config.unlock_interval, 'ms');
      }
    }
    // Dated Event
    else if (event && event.is_dated) {
      const now = moment().utc();
      const startTime = moment(event.start_time);
      const endTime = moment(event.end_time);

      if (event.virtual_intervals && event.virtual_intervals.unlock_interval) {

        const eventIntervalEndTime = moment(event.start_time).add(event.virtual_intervals.unlock_interval, 'ms');
        const nowIntervalEndTime = moment().add(event.virtual_intervals.unlock_interval, 'ms');

        if (startTime.isAfter(now) && endTime.isAfter(eventIntervalEndTime)) {
          unlockStart = startTime;
          unlockEnd = eventIntervalEndTime;
        }

        else if (startTime.isAfter(now) && endTime.isBefore(eventIntervalEndTime)) {
          unlockStart = startTime;
          unlockEnd =  endTime;
        }

        else if (startTime.isBefore(now) && endTime.isAfter(eventIntervalEndTime) && endTime.isAfter(nowIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = nowIntervalEndTime;
        }

        else if (startTime.isBefore(now) && endTime.isAfter(eventIntervalEndTime) && endTime.isBefore(nowIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = endTime;
        }

        else if (startTime.isBefore(now) && endTime.isBefore(eventIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = endTime;
        }

      }
      else if (!event.virtual_intervals) {

        const bucketIntervalEndTime = moment(event.start_time).add(appSettings.virtual_festival_config.unlock_interval, 'ms');
        const nowIntervalEndTime = moment().add(appSettings.virtual_festival_config.unlock_interval, 'ms');

        if (startTime.isAfter(now) && endTime.isAfter(bucketIntervalEndTime)) {
          unlockStart = startTime;
          unlockEnd = bucketIntervalEndTime;
        }

        else if (startTime.isAfter(now) && endTime.isBefore(bucketIntervalEndTime)) {
          unlockStart = startTime;
          unlockEnd =  endTime;
        }

        else if (startTime.isBefore(now) && endTime.isAfter(bucketIntervalEndTime) && endTime.isAfter(nowIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = nowIntervalEndTime;
        }

        else if (startTime.isBefore(now) && endTime.isAfter(bucketIntervalEndTime) && endTime.isBefore(nowIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = endTime;
        }

        else if (startTime.isBefore(now) && endTime.isBefore(bucketIntervalEndTime)) {
          unlockStart = now;
          unlockEnd = endTime;
        }

      }

      unlockStart.tz(moment.tz.guess());
      unlockEnd.tz(moment.tz.guess());
    }

    return { unlockStart, unlockEnd }
  }

  render() {
    let { order, person, pass, event } = this.props,
      tickets = order.tickets.map(t => this.props.getTicketById(t.id) || t),
      passes = order.passes.map(p => this.props.getPassById(p.id) || p),
      { items } = order,
      isGift = passes.some(p => p.pending_gift_claim_url),
      hasUnfilledData = passes.length
        ? passes.some(
            p => p.needs_supplementary_data && !p.pending_gift_claim_url
          )
        : false,
      hasUnnamedPasses = passes.length
        ? !passes.every(
            p => p.name !== "Unnamed Pass" || p.pending_gift_claim_url
          )
        : false,
      passBucket = passes.length && passes[0].pass_bucket,
      styles = this.getStyles();

    let creationMoment = moment(order.created_at);

    let ticketItems = values(groupBy(tickets, t => t.event.id)).map(
      tickets => {
        return {
          event: tickets[0].event,
          tickets: tickets
        };
      }
    );

    let isVirtual = false;
    let isWaitlistBadge = order.passes && order.passes.length && order.passes[0].code === "waitlistBadge";
    if (ticketItems && ticketItems[0] && ticketItems[0].event) {
      isVirtual = ticketItems[0].event.is_virtual;
    }

    const timezone = this.context.appSettings.timezone;

    const display_passes_or_memberships = this.context.tenant.membership_enabled ? this.context.tenant.display_memberships : this.context.tenant.display_passes;
    const display_pass_or_membership = this.context.tenant.membership_enabled ? this.context.tenant.display_membership : this.context.tenant.display_pass;

    return (
      <div id="Eventive--orderSummary--orderSuccess" style={styles.container}>
        <div style={styles.general}>
          {isVirtual ? (
            <div style={{ paddingBottom: 15 }}>
              Your order has been processed successfully. Check your email for your ticket confirmation
              and event information. When you are ready to begin watching your content, click
              'Watch Now' on the screening page.
            </div>
          ) : isWaitlistBadge ? (
            <div style={{ paddingBottom: 15 }}>
              Your waitlist badge has been added to your account.
            </div>
          ) : (
            <div>
              A copy of the following ticket(s) has been emailed to you.
              When it's time for the event, make sure you have your tickets ready
              to present at the door (printed or electronic).
            </div>
          )}
          {person && !isVirtual && !isWaitlistBadge ? <SmsTicketsWidgetSundance large={this.context.isLarge} /> : null}
          {order.gift_cards && order.gift_cards.length ?
            (<div style={{ marginTop: 15 }}>
              <InjectedTenantHTML
                content={this.context.tenant.gift_cards_success}
              />
              <div>
                <p>
                  An email has been sent to your gift card recipient. You may also provide them with the following:
                </p>
              </div>
              {order.gift_cards.map((gc) =>
                (<div style={{ marginTop: 15, marginBottom: 10, fontSize: 24 }}>Gift Card Code: <font style={{ fontWeight: "bold" }}>{gc.code}</font></div>)
              )}
            </div>)
          : null}
        </div>
        <div style={styles.innerContainer}>
          {tickets.length ? (
            <div>
              <div style={styles.listing}>
                <div style={{
                  display: "flex",
                  //flexWrap: "wrap",
                  flexDirection: "row",
                  justifyContent: "space-between"
                }}>
                  <div style={{ width: this.context.isLarge ? "auto" : "100%", maxWidth: this.context.isLarge ? "50%" : "100%", backgroundColor: "#fff", padding: 20, borderRadius: 10 }}>
                    {ticketItems.map(event => (
                      <div>
                        <div style={{ color: "#000", fontWeight: "bold", fontSize: "1em", paddingBottom: 10 }}>{event.event.name}</div>
                        <div style={{ color: "#000", fontWeight: "bold", fontSize: "0.75em" }}>{event.tickets.length} TICKET{event.tickets.length !== 1 ? "S" : ""}</div>
                        {!event.event.is_virtual ? (
                          <div style={{ fontSize: "0.75em" }}>{moment(event.event.start_time).tz(timezone).format("MMM D, h:mm a")} - {moment(event.event.end_time).tz(timezone).format("MMM D, h:mm a z")}</div>
                        ) : (
                          <div style={{ fontSize: "0.75em" }}>{this.getUnlockInterval(event.event, creationMoment).unlockStart.format("MMM D, h:mm a")} - {this.getUnlockInterval(event.event, creationMoment).unlockEnd.format("MMM D, h:mm a z")}</div>
                          )}
                        {!event.event.is_virtual ? (
                          <div>
                           {this.getSundanceDisplayTag(event.event) ? (
                              <div style={{ fontSize: "0.75em" }}>{this.getSundanceDisplayTag(event.event)}</div>
                            ) : null}
                            {event.event.venue && event.event.venue.name ? (
                              <div style={{ fontSize: "0.75em" }}>{event.event.venue.name}</div>
                            ) : null}
                            <div style={{ fontSize: "0.75em" }}>{this.getSundanceVenueCity(event.event.venue)}</div>
                          </div>
                        ) : null}
                        {event.event.is_virtual ? (
                          <div style={{ fontSize: "0.75em" }}>ONLINE</div>
                        ) : null}
                      </div>
                    ))}
                  </div>
                  <div style={{ width: this.context.isLarge ? "50%" : "100%", maxWidth: this.context.isLarge ? "50%" : "100%", backgroundColor: "#ddd", padding: 20 }}>
                    <div style={{ color: "#000", fontWeight: "bold", fontSize: "0.75em", paddingTop: this.context.isLarge ? 30 : 0 }}>Order Information</div>
                    <div style={{ fontSize: "0.75em" }}>Order #: {order.id}</div>
                    <div style={{ fontSize: "0.75em" }}>Ordered: {creationMoment.format("MMM D, h:mm a z")}</div>
                    {pass ? (
                      <div style={{ fontSize: "0.75em" }}>Order Option: {pass.pass_bucket.name}</div>
                    ) : null}
                    <div style={{ fontSize: "0.75em" }}>Amount: {formatPrice(order.purchase_price)}</div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {passes.length ? (
            <div>
              <h3 style={styles.inOrderSubhead}>
                {capitalize(display_passes_or_memberships)} in this order
              </h3>
              {hasUnfilledData ? (
                <p style={{ marginTop: "-0.75em" }}>
                  We need a little more information from you before we can
                  complete your order. To begin, click the "edit details" button
                  next to{" "}
                  {passes.length === 1
                    ? `your ${display_pass_or_membership}`
                    : `each of your ${display_passes_or_memberships}`}
                  .
                </p>
              ) : hasUnnamedPasses ? (
                <p style={{ marginTop: "-0.75em" }}>
                  First things first, name your{" "}
                  {display_passes_or_memberships} by entering a name and
                  then clicking "Save name" next to each{" "}
                  {display_pass_or_membership}. You'll use this name to
                  distinguish between {display_passes_or_memberships} when
                  ordering tickets, and it will also be printed on your physical{" "}
                  {display_pass_or_membership}.
                </p>
              ) : null}
              <div style={styles.listing}>
                <PassList
                  passes={passes}
                  onChange={this.onPassChange}
                  hideSettingsLink={true}
                  hideActions={true}
                  initalEditing={!hasUnfilledData && hasUnnamedPasses && true}
                />
              </div>
              {isGift ? (
                <div>
                  Thank you for your gift purchase of {passes.length}{" "}
                  {passes.length === 1
                    ? display_pass_or_membership
                    : display_passes_or_memberships}
                  . A PDF containing a gift certificate for each{" "}
                  {this.context.tenant.display_pass} has been emailed to you.
                  You can also use the links above to send the gift certificate
                  directly to your recipient along with a personalized message.
                </div>
              ) : !hasUnfilledData && !hasUnnamedPasses ? (
                <InjectedTenantHTML
                  id="Eventive--orderSummary--passDetailsSubmitted"
                  content={
                    isWaitlistBadge
                      ? { __html: "Your order has been completed successfully. You will be able to use this waitlist badge to enter a screening that you are on the waitlist for and that has available space in the theater. Enjoy your screening!" }
                      : passBucket.confirmation_email_message
                      ? { __html: passBucket.confirmation_email_message }
                      : this.context.tenant.order_passes_success
                  }
                />
              ) : null}
            </div>
          ) : null}
          {items.length &&
          items[0].item_bucket.code === "donation" &&
          !passes.length &&
          !tickets.length ? (
            <div style={styles.items}>
              <h3 style={styles.inOrderSubhead}>Thank you for your donation</h3>
              <InjectedTenantHTML
                content={this.context.tenant.donation_success}
              />
            </div>
          ) : null}
        </div>

        <div style={styles.actions}>
          {hasUnfilledData ? (
            <div style={styles.error}>
              Please submit all required details for your{" "}
              {passes.length !== 1
                ? display_passes_or_memberships
                : display_pass_or_membership}{" "}
              before continuing, or{" "}
              <Link to={`/${this.context.tenant.passes_url_pathname}`}>
                save for later
              </Link>
              .
            </div>
          ) : hasUnnamedPasses ? (
            <div style={styles.error}>
              {`Please name your ${
                passes.length !== 1
                  ? display_passes_or_memberships
                  : display_pass_or_membership
              } before continuing.`}
            </div>
          ) : null}
          <div style={{ marginTop: -12, display: "none" }}>
            <RaisedButton
              label="Go back"
              disabled={hasUnfilledData || hasUnnamedPasses}
              onClick={() => {
                this.context.router.goBack();
              }}
              style={{ marginTop: 12 }}
            />
            {!window.EVENTIVE_IS_EVERYWHERE &&
            !window.GIFT_CARD_ORDER &&
            !this.context.router.isActive("/schedule") &&
            this.context.appSettings.schedule_enabled ? (
              <RaisedButton
                label={`Go to ${this.context.tenant.display_schedule}`}
                disabled={hasUnfilledData || hasUnnamedPasses}
                onClick={() => {
                  this.context.router.push("/schedule");
                }}
                style={{ marginTop: 12, marginLeft: 12 }}
              />
            ) : null}
            {!window.EVENTIVE_IS_EVERYWHERE &&
            (passes.length || (tickets.length && !order.box_office_email)) ? (
              <RaisedButton
                label={
                  tickets.length
                    ? "Go to my tickets"
                    : passes.length
                    ? `Go to my ${display_passes_or_memberships}`
                    : "Return home"
                }
                disabled={hasUnfilledData || hasUnnamedPasses}
                onClick={() =>
                  this.context.router.push(
                    tickets.length
                      ? "/tickets"
                      : passes.length
                      ? `/${this.context.tenant.passes_url_pathname}`
                      : "/welcome"
                  )
                }
                style={{ marginTop: 12, marginLeft: 12 }}
              />
            ) : null}
          </div>
        </div>

        {this.context.tenant.order_completion_scripts ? (
          <InjectedTenantScripts
            content={this.context.tenant.order_completion_scripts}
          />
        ) : null}
      </div>
    );
  }
}

export default OrderSummarySundance;



// WEBPACK FOOTER //
// ./src/app/components/partials/order-summary-sundance.jsx